import template from './trip-availability-item.html';
import tripItemTypes from './../../trip-item-types';

const DIRECTIVE_NAME = TripAvailabilityItem.DIRECTIVE_NAME = 'ktTripAvailabilityItem';
export default function TripAvailabilityItem() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripAvailabilityItemController,
        controllerAs: '$ctrl',
        scope: {
            item: `=${DIRECTIVE_NAME}`,
            priceChanged: `=${DIRECTIVE_NAME}PriceChanged`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripAvailabilityItemController(
    userService,
    tripTravellerAllocationPassengerService,
    tripItemFlightRecommendationService,
    tripItemRailRecommendationService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        tripItemTypes,
        getTrainRoute,
        getTravellerFullName: tripTravellerAllocationPassengerService.getTravellerFullName,
        getFlightRoute,
        itemIsFlightProduct,
        itemIsEurostarProduct,
        itemIsHotelProduct,
        itemIsCarProduct,
        itemIsRailProduct,
        itemIsEuRailProduct,
        itemIsSeatProduct,
        isEurostarAirline,
    });

    function $onInit() {
        vm.regionalSettings = userService.getRegionalSettings();
    }

    function getFlightRoute() {
        return tripItemFlightRecommendationService.getFlightRecommendationAirportCodeRoute(vm.item)
            .join(' - ');
    }

    function getTrainRoute() {
        return tripItemRailRecommendationService.getKeyStations(vm.item)
            .join(' - ');
    }

    function itemIsFlightProduct() {
        return vm.item.TripItemType === tripItemTypes.flight;
    }

    function itemIsEurostarProduct() {
        return vm.item.TripItemType === tripItemTypes.eurostar;
    }

    function itemIsHotelProduct() {
        return vm.item.TripItemType === tripItemTypes.hotel;
    }

    function itemIsCarProduct() {
        return vm.item.TripItemType === tripItemTypes.car;
    }

    function itemIsRailProduct() {
        return vm.item.TripItemType === tripItemTypes.rail;
    }

    function itemIsEuRailProduct() {
        return vm.item.TripItemType === tripItemTypes.eurail;
    }

    function itemIsSeatProduct() {
        return vm.item.TripItemType === tripItemTypes.seat;
    }

    function isEurostarAirline() {
        return vm.item.FlightGroups
            && vm.item.FlightGroups
            && vm.item.FlightGroups.length
            && vm.item.FlightGroups[0].Flights
            && vm.item.FlightGroups[0].Flights.length
            && vm.item.FlightGroups[0].Flights[0].MarketingAirline === 'Eurostar';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-availability-item/trip-availability-item-component.js